import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../hooks/useAuth';

// Handles {origin}/#session_id=... after Emergent Google sign-in.
// Exchanges session_id server-side, receives dsk_session cookie + API key, then returns to the dashboard.
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    const finish = (ok) => {
      window.history.replaceState(null, '', window.location.pathname);
      navigate(ok ? '/' : '/?auth=google_failed', { replace: true });
    };
    if (!sessionId) { finish(false); return; }

    fetch(`${API_URL}/api/auth/google/session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data.api_key) {
          sessionStorage.setItem('dsk_key', data.api_key);
          if (data.label) localStorage.setItem('designsync_api_label', data.label);
          if (data.email) localStorage.setItem('designsync_user_email', data.email);
          finish(true);
        } else {
          finish(false);
        }
      })
      .catch(() => finish(false));
  }, [location.hash, navigate]);

  return null;
};

export default AuthCallback;
